const visibilityValueFieldToTextMap = new Map([
  ['VisibleOnAggregateAppraisalReport', 'Aggregate Appraisal Report'],
  ['VisibleOnDetailedAppraisalReport', 'Detailed Appraisal Report'],
  ['VisibleOnAppraisalView', 'Appraisal View'],
  ['VisibleOnAppraisalComparison', 'Appraisal Comparison']
]);

export default visibilityValueFieldToTextMap;
